import React, {useState} from 'react'
import {Row, Col} from 'antd';
import {Modal, Button} from 'antd';
import {Player, ControlBar} from 'video-react';
import ReactPlayer from 'react-player';
import uparrow from '../../Assests/assets/images/icons-8-expand-arrow.png';
import downarrow from '../../Assests/assets/images/icons-8-down-arrow.png';
import playicon from '../../Assests/assets/images/icons-8-play-button-circled.png';
import './Module.css';
//import '~video-react/dist/video-react.css'; // import css

const Module = (props) => {
  var [isOpen,setIsOpen] = useState(false);
  var [isPlayingVideo, setIsPlayingVideo] = useState(false);
  var [videoSRC, setVideoSRC] = useState('');
  var [isLoggedIn, setIsLoggedIn] = useState(props.isLoggedIn);
  var playVideo = function(src) {
    console.log('playing video');
    setVideoSRC(src);
    setIsPlayingVideo(true);
    return;
  };
  var  createCourseElement = function(course, index) {
    console.log(course);
    var LoggedOutView = (
      <>
        <Row>
          <Col md={1}>
                <div class='module-content-play-icon'>
                  <img src={playicon}/>
                </div>
          </Col>
          <Col md={19}> 
                <div class='module-content-text'>
                  {course.video_key}
                </div>
          </Col>
          <Col md={4}>
                <div class='module-content-duration'>
                  {course.total_time_duration}
                </div>
          </Col>
        </Row>
      </>
    );
    var LoggedInView = (
      <>
              <Row>
                <Col md={1}>
                  <div class='module-content-play-icon'>
                    <img src={playicon}/>
                  </div>
                </Col>
                <Col md={19}>
                  <div class='module-content-text'>
                    <Row>
                      <Col xs={24} sm={24} md={20}>
                        <span class='module-content-text-title'>
                          {course.video_key}
                        </span>
                      </Col>
                      <Col xs={24} sm={24} md={4}>
                        <span class='module-loggedin-content-duration'>
                          ({course.total_time_duration})
                        </span>
                      </Col>
                    </Row>
                    <Row>
                      <p>
                        This session explains Comparative Statements, 
                        which is one of the most effective tool to 
                        analyse the Financial Statements
                      </p>
                    </Row>
                  </div>
                </Col>
                <Col md={4}>
                  <div class='module-loggedin-content-start-btn-container'>
                    <button class='module-loggedin-content-start-btn'>
                      <span class='module-logged-content-start-btn-text' onClick={() => playVideo('https://media.w3.org/2010/05/sintel/trailer_hd.mp4')}>
                        Start
                      </span>
                    </button>
                  </div>
                </Col>
              </Row>
      </>
    );
    return (
            <div class='module-content-title-rect' key={index}>
              <div class='module-content-title'>
                {props.isLoggedIn && props.is_bought && LoggedInView}
                {props.isLoggedIn && !props.is_bought && LoggedOutView}
                {!props.isLoggedIn && LoggedOutView}
              </div>
            </div>
    );
  }
  var constructCourseElement = function(coursesObjArray) {
    var courseElements = [];
    var courseElement;
    coursesObjArray.forEach((course, index) => {
      courseElement = createCourseElement(course, index);
      courseElements.push(courseElement);
    });
    return courseElements;
  }

  return (
    <div class='module-container'>
      <div class='module-header-container' onClick={() => setIsOpen(!isOpen)}>
        <Row>
          <Col md={1} lg={1}>
            <span class='module-header-expand-arrow'>
              {isOpen && <img src={uparrow}/>}
              {!isOpen && <img src={downarrow}/>}
            </span>
          </Col>
          <Col md={19} lg={15}>
            <span class='module-header-text'>
              {/*Module-1 Introduction and Basics*/}
              {props.name}
            </span>
          </Col>
          <Col md={2} lg={4}>
            <span class='module-header-num-lectures'>
              {props.num_lectures} Lectures
            </span>
          </Col>
          <Col md={2} lg={4}>
            <span class='module-header-duration'>
              {props.total_time}
            </span>
          </Col>
        </Row>
      </div>
      <div class='module-content-container'>
      { isOpen &&
           constructCourseElement(props.lectures)
      }
      </div>
      {/*
      <Player>
        <source src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4" />
        <ControlBar autoHide={false} />
      </Player>
      */}
              <Modal
                  style={{ top: 20,
                           background: 'transparent',
                   }}
                  visible={isPlayingVideo}
                  width="50%"
                  footer={null}
                  destroyOnClose="true"
                  onOk={() => setIsPlayingVideo(false)}
                  onCancel={() => setIsPlayingVideo(false)}
                        >
                {/*<ReactPlayer url='https://media.w3.org/2010/05/sintel/trailer_hd.mp4' controls='true'/>*/}
                  <ReactPlayer url={videoSRC} controls='true'/>
              </Modal>
    </div>
  )
}
export default Module;
